<template>
  <div class="dashboard-contanier">
    <swiper
      :options="swiperOption"
      ref="mySwiper"
      class="mySwiper swiper-no-swiping"
      style="height: 100%"
    >
      <flowData></flowData>
      <!-- <newpage1/> -->
      <!-- <newpage2/> -->
      <!-- <newpage3/> -->
      <!-- <newpage4/> -->
      <!-- <newpage5/> -->
      <!-- <dataCustomer></dataCustomer> -->
      <tagData></tagData>
      <!-- <industryData></industryData> -->
      <!-- <brandResource></brandResource> -->
      <!-- <lab></lab> -->
      <!-- <enterpriseStrength></enterpriseStrength> -->
    </swiper>
    <div class="swiper-button-next" slot="swiper-button-next"></div>
    <div class="swiper-button-prev" slot="swiper-button-prev"></div>
    <div
      :class="btnPlay ? 'el-icon-video-pause' : 'el-icon-video-play'"
      class="pauseBtn"
      @click="stop"
    ></div>
  </div>
</template>
<script>
import flowData from "@/components/flowData.vue";
import tagData from "@/components/tagData.vue";
import industryData from "@/components/industryData.vue";
import brandResource from "@/components/brandResource.vue";
import lab from "@/components/lab.vue";
import enterpriseStrength from "@/components/enterpriseStrength.vue";
import dataCustomer from "@/components/dataCustomer.vue";
import newpage1 from '@/components/newpage1.vue';
import newpage2 from '@/components/newpage2.vue';
import newpage3 from '@/components/newpage3.vue';
import newpage4 from '@/components/newpage4.vue';
import newpage5 from '@/components/newpage5.vue';
import "echarts/lib/chart/map";
import "echarts/map/js/china.js";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
export default {
  name: "index",
  components: {
    swiper,
    swiperSlide,
    flowData,
    tagData,
    industryData,
    brandResource,
    lab,
    enterpriseStrength,
    dataCustomer,
    newpage1,
    newpage2,
    newpage3,
    newpage4,
    newpage5
  },
  data() {
    return {
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        // loop: true,
        noSwiping: true,
        spaceBetween: 0,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        speed: 1000
      },
      btnPlay: true
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    stop() {
      //通过调用鼠标移入移除间接实现暂停播放
      this.btnPlay = !this.btnPlay;
      this.btnPlay ? this.swiper.autoplay.start() : this.swiper.autoplay.stop();
    }
  }
};
</script>
<style lang="less" scoped>
.dashboard-contanier {
  width: 100%;
  height: 100%;
  .pauseBtn {
    position: absolute;
    z-index: 999;
    top: 10px;
    font-size: 70px;
    color: skyblue;
    right: 20px;
    cursor: pointer;
  }
}
</style>
